/** Envelope glyph (mail contact) */
export const Email = () => (
  <svg
    aria-label="Email"
    role="img"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <rect x="2" y="4" width="20" height="16" rx="2.5" />
    <path d="M2 7l10 7 10-7" />
  </svg>
);
